import { IContractValue } from "@components/global/new/ContractSelector/ContractSelector.props";
import { IMiningPlanOptions } from "@services/getMinerList";
import { draggableHTMLID } from "@store/minersSelect/reducer";

export const SELECTOR_CONTRACT_ID = "selector-contractid";

const MINER_DATA_CONRACT = "data-miner_contract";
const SELECTOR_DATA_CONTRACT = "data-contract";

class MinerContractService {
  minerRow: Element | null;
  contractSelector: Element | null;

  constructor() {
    this.minerRow = null;
    this.contractSelector = null;
  }

  private makeMinerElement(minerId: number) {
    const id = `#${draggableHTMLID(String(minerId))}`;
    if (!this.minerRow || id !== this.minerRow.id) {
      const minerRow = document.querySelector(id);
      this.minerRow = minerRow;
    }
  }

  // пока селектор как константа
  private makeSelectorElement(id = `#${SELECTOR_CONTRACT_ID}`) {
    if (!this.contractSelector || id !== this.contractSelector.id) {
      const contractSelector = document.querySelector(id);
      this.contractSelector = contractSelector;
    }
  }

  getMinerContract(minerId: number): IContractValue | undefined {
    this.makeMinerElement(minerId);
    const contract = this.minerRow?.getAttribute(MINER_DATA_CONRACT);
    if (!contract) return undefined;

    return JSON.parse(contract);
  }

  setMinerContract(minerId: number, contract?: IContractValue) {
    this.makeMinerElement(minerId);
    this.minerRow?.setAttribute(
      MINER_DATA_CONRACT,
      JSON.stringify(contract || "{}")
    );
    return this;
  }

  getSelectorContract(): IMiningPlanOptions | undefined {
    this.makeSelectorElement();
    const contract = this.contractSelector?.getAttribute(
      SELECTOR_DATA_CONTRACT
    );
    console.log(
      contract,
      this.contractSelector?.getAttribute(SELECTOR_DATA_CONTRACT)
    );
    if (!contract) return undefined;

    return JSON.parse(contract);
  }

  setSelectorContract(contract?: IContractValue) {
    this.makeSelectorElement();
    this.contractSelector?.setAttribute(
      SELECTOR_DATA_CONTRACT,
      JSON.stringify(contract || "{}")
    );
    return this;
  }
}

export const minerContractService = new MinerContractService();
